(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/route-result/assets/javascripts/result-settings-selector-container.js') >= 0) return;  svs.modules.push('/components/tipsen/route-result/assets/javascripts/result-settings-selector-container.js');
"use strict";


const {
  CouponSettingsSelector
} = svs.components.tipsen.couponSettingsSelector;
const {
  useFilteredTipsinfoOptions,
  useFilteredOutcomeInfoChoises
} = svs.components.tipsen.tipsinfo;
const {
  selectModuleName
} = svs.components.tipsen.engine.selectors.engineSelectors;
const {
  useSelector,
  useDispatch
} = ReactRedux;
const {
  setResultTipsinfo,
  setOutcomeInfoChoises
} = svs.components.tipsen.store.actions.couponSettingsActions;
const {
  RadioButton
} = svs.ui.reactForm;
const {
  TipsinfoTypes
} = svs.components.tipsen.engine.constants;
const {
  ReactButton
} = svs.ui;
const {
  selectOutcomeInfoChoise
} = svs.components.tipsen.selectors;
const {
  useContext
} = React;
const {
  RenderContext
} = svs.component.tipsen.renderContext;
const ResultSettingsSelectorContainer = () => {
  const {
    pageType
  } = useContext(RenderContext);
  const dispatch = useDispatch();
  const tipsinfoOptions = useFilteredTipsinfoOptions();
  const moduleName = useSelector(selectModuleName);
  const outcomeInfoChoises = useFilteredOutcomeInfoChoises();
  const selectedOutcomeChoise = useSelector(state => selectOutcomeInfoChoise(state, pageType));
  const onTipsinfoChange = (field, state) => {
    dispatch(setResultTipsinfo({
      moduleName,
      changes: [{
        field,
        state
      }]
    }));
  };
  const onToggleBetButtonDisplay = e => {
    var _e$currentTarget$valu, _e$currentTarget;
    const value = (_e$currentTarget$valu = (_e$currentTarget = e.currentTarget) === null || _e$currentTarget === void 0 ? void 0 : _e$currentTarget.value) !== null && _e$currentTarget$valu !== void 0 ? _e$currentTarget$valu : e;
    dispatch(setOutcomeInfoChoises({
      moduleName,
      changes: [{
        field: 'displayResult',
        state: value
      }]
    }));
  };
  return React.createElement(React.Fragment, null, React.createElement(CouponSettingsSelector, null, React.createElement(CouponSettingsSelector.CouponSettingsHeading, null, "Tipsinfo"), React.createElement("div", {
    className: "pg_coupon_settings__tipsinfo_wrapper"
  }, tipsinfoOptions === null || tipsinfoOptions === void 0 ? void 0 : tipsinfoOptions.map(_ref => {
    let {
      isSelected,
      title,
      key
    } = _ref;
    return React.createElement(ReactButton, {
      "aria-checked": isSelected,
      className: "result-coupon-tipsinfo-btn",
      "data-testid": "test-id-".concat(key),
      disabled: selectedOutcomeChoise.display === TipsinfoTypes.SvenskaFolket && selectedOutcomeChoise.display.toLowerCase() === key.toLowerCase(),
      inverted: isSelected,
      key: key,
      onClick: () => {
        onTipsinfoChange(key, !isSelected);
      },
      role: "checkbox",
      thin: true,
      transparent: !isSelected
    }, "+", ' ', title);
  }))), React.createElement(CouponSettingsSelector, null, React.createElement(CouponSettingsSelector.CouponSettingsHeading, null, "Tecken i utfall"), React.createElement(CouponSettingsSelector.CouponSettingsButtons, null, outcomeInfoChoises.map(_ref2 => {
    let {
      isSelected,
      title,
      key
    } = _ref2;
    return React.createElement(RadioButton, {
      checked: isSelected,
      key: key,
      onChange: onToggleBetButtonDisplay,
      value: key
    }, title);
  }))));
};
setGlobal('svs.components.tipsen.routeResult.ResultSettingsSelectorContainer', ResultSettingsSelectorContainer);

 })(window);